import React, { memo } from 'react';
export function Benefits() {
  return <section id="beneficios" className="py-10 bg-white" data-id="element-32">
      <div className="container mx-auto px-4" data-id="element-33">
        <div className="max-w-3xl mx-auto text-center mb-8" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-35">
            ¿Qué Ganarás con Esta Guía?
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-36">
          <div className="bg-orange-50 p-6 rounded-lg shadow-md" data-id="element-37">
            <div className="flex items-center mb-3" data-id="element-38">
              <div className="text-4xl text-orange-500 mr-3" data-id="element-39">✨</div>
              <h3 className="text-xl font-semibold text-gray-800" data-id="element-40">
                Hijos que hablan español con naturalidad y orgullo
              </h3>
            </div>
            <p className="text-gray-600" data-id="element-41">
              Verás cómo tus hijos pasan de resistirse a hablar español a
              disfrutarlo y sentirse orgullosos de su herencia lingüística.
            </p>
          </div>
          <div className="bg-orange-50 p-6 rounded-lg shadow-md" data-id="element-42">
            <div className="flex items-center mb-3" data-id="element-43">
              <div className="text-4xl text-orange-500 mr-3" data-id="element-44">✨</div>
              <h3 className="text-xl font-semibold text-gray-800" data-id="element-45">
                Mejores habilidades cognitivas y rendimiento escolar
              </h3>
            </div>
            <p className="text-gray-600" data-id="element-46">
              El bilingüismo desarrolla áreas del cerebro relacionadas con la
              atención, la memoria y la resolución de problemas.
            </p>
          </div>
          <div className="bg-orange-50 p-6 rounded-lg shadow-md" data-id="element-47">
            <div className="flex items-center mb-3" data-id="element-48">
              <div className="text-4xl text-orange-500 mr-3" data-id="element-49">✨</div>
              <h3 className="text-xl font-semibold text-gray-800" data-id="element-50">
                Una conexión cultural profunda que no se rompe
              </h3>
            </div>
            <p className="text-gray-600" data-id="element-51">
              Mantén vivas las tradiciones familiares y fortalece los lazos con
              abuelos y otros familiares que hablan español.
            </p>
          </div>
          <div className="bg-orange-50 p-6 rounded-lg shadow-md" data-id="element-52">
            <div className="flex items-center mb-3" data-id="element-53">
              <div className="text-4xl text-orange-500 mr-3" data-id="element-54">✨</div>
              <h3 className="text-xl font-semibold text-gray-800" data-id="element-55">
                La tranquilidad de darles una ventaja que durará toda la vida
              </h3>
            </div>
            <p className="text-gray-600" data-id="element-56">
              En un mundo globalizado, el bilingüismo abre puertas académicas y
              profesionales que marcarán su futuro.
            </p>
          </div>
        </div>
      </div>
    </section>;
}